import React, {Component} from 'react'
import Helmet from "react-helmet";
import {Button, message, Modal,Badge,Spin } from 'antd'
import Logo from '../../assets/images/mobile-logo.png'
import LinkIcon from './images/link-icon.png'
import EnterPrise from './images/enterprise.png'
import NoCompany from './images/no-company.png'
import './subscribe.less'
import queryString from "query-string";
import ajax from "../../api/ajax";
import {baseUrl} from "../../api";
import successset from "./images/success-set.png"
import errSet from "./images/err-set.png"
import subCode from "./images/subcode.png";
import wx from "./images/wx.png";
const { confirm } = Modal;
const redirect_url = window.location.origin+"/crm/sub?";
const wx_ser_url= baseUrl.split("/").slice(0,3).join("/")+"/wechat"
//const wx_ser_url= "http://192.168.10.110:8090"+"/wechat"
const wx_url = "https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx239460a0813ea627&redirect_uri="
class SubscribeList extends Component {
    state={
        openid:null,
        sub:null,
        nickname:null,
        msg:null,
        subInfo:{},
        subList:[],
        status:"",
        visible:false,
        loading:false,
        allloading:false,
    }
    subInfo={}
    levels={
        1:"一般",
        2:"严重"
    }
    getSubStr=(subInfo)=>{
        if(subInfo.type ==="user"){
            return subInfo.userName?subInfo.userName:subInfo.value
        }else if(subInfo.type ==="all"){
            return "所有订单"
        }
    }
    getWxUrl=()=>{
        let catUrl=""
        let wx_redirect_url = redirect_url
        if (JSON.stringify(this.subInfo) !== '{}' && this.subInfo.type){
            catUrl=queryString.stringify(this.subInfo)
        }
        wx_redirect_url = encodeURIComponent(wx_redirect_url+catUrl)
        wx_redirect_url = wx_url+wx_redirect_url+"&response_type=code&scope=snsapi_userinfo&state=a#wechat_redirect"

        return wx_redirect_url
    }
    gotoWx=()=>{
        window.location.replace(this.getWxUrl())
    }
    storeToken=(token)=>{
        if(token && token.expiresIn){
            let expiresIn = token.expiresIn
            let dtNow = new Date()
            dtNow.setSeconds(dtNow.getSeconds()+expiresIn/2)
            let wxToken = Object.assign(token,{expireDt:dtNow})
            window.localStorage.setItem("wxToken",JSON.stringify(wxToken))
        }
    }
    readToken=()=>{
        let tokenStr = window.localStorage.getItem("wxToken");
        if(tokenStr && JSON.parse(tokenStr)){
            let token = JSON.parse(tokenStr)
            let expireDt = new Date(token.expireDt)
            let dt = new Date()
            if(token.expireDt && expireDt.getTime()>dt.getTime()){
                return token
            }else{
                return {}
            }
        }
        return {}
    }
    getToken=(code)=>{
        //return null;
        this.setState({
            allloading:true
        })
        let result = ajax(wx_ser_url+"/token?code="+code);
        result.then((resp)=>{
            let info = Object.assign({},resp.token,resp.user)
            if(resp && resp.token){
                this.storeToken(info)
            }
            if(resp&& resp.user){
                this.setState({
                    openid:resp.user.openid,
                    sub:resp.user.subscribe,
                    nickname:resp.user.nickname
                })
            }

            if(resp && resp.user && resp.user.subscribe!==1){
                this.doCheckSub();
            }else if(resp && resp.user && resp.user.subscribe===1){
                this.doSuccess()
            }
            if(!resp || !resp.user){
                this.wxReset();
                this.setState({
                    msg:"发生错误，请重新扫码"
                })
            }
            let query = queryString.parse(this.props.location.search)
            if(query&& query.code){
                delete query.code;
                delete query.state;
                this.props.history.replace("/sub?"+queryString.stringify(query))
            }
        }).finally(()=>{
            this.setState({
                allloading:false
            })
        })
    }
    getUserInfo=()=>{
        let wxToken = this.readToken();
        let token = wxToken.accessToken;
        let openId = wxToken.openid;
        if (token && openId) {
            this.checkToken(token, openId)
        } else {
            //alert(redirect_url+orderNo)
            this.gotoWx()
        }
    }
    getSubList=()=>{
        let wxToken = this.readToken();
        let token = wxToken.accessToken;
        let openId = wxToken.openid;
        let data = {openid:openId,token:token}
        this.setState({
            allloading:true
        })
        let result = ajax(baseUrl+"/d/public/subscribes",data);
        result.then((resp)=>{
            if(resp&&resp.code===400){
                this.setState({
                    msg:resp.message+"，请重新扫码"
                })
                //this.wxReset();
            }else{
                this.setState({
                    subList:resp.data,
                    status:"订阅清单："
                })
            }
        }).catch(()=>{
            this.setState({
                subList:[]
            })
        }).finally(()=>{
            this.setState({
                allloading:false
            })
        })
    }
    doCheckSub=()=>{
        setTimeout(this.getUserInfo,2000)
    }
    doSuccess=()=>{
        if (JSON.stringify(this.subInfo) !== '{}' && this.subInfo.type){
            this.doSub(this.subInfo)
        }else{
            this.getSubList()
        }
    }
    doSub=(subInfo)=>{
        let data = new FormData();
        let post=false
        if(Number.isInteger(subInfo)){
            data.append("id",subInfo)
            post=true
        }else{
            let type = subInfo.type
            let value= subInfo.value
            let level= subInfo.level
            let wxToken = this.readToken();
            let token = wxToken.accessToken;
            let openId = wxToken.openid;
            let nickName = wxToken.nickname
            let address = wxToken.country+wxToken.province+wxToken.city
            if(type) {
                data.append("openid", openId)
                data.append("token", token)
                data.append("type", type)
                data.append("nickName", nickName)
                data.append("address", address)
                if(level){
                    data.append("level", level)
                }
                if(value) {
                    data.append("value", value)
                }
                post=true
            }
        }

        if(post){
            this.setState({
                allloading:true
            })
            let result = ajax(baseUrl+"/d/public/subscribe",data,"POST");
            result.then((resp)=>{
                if (resp && resp.code === 201) {
                    let content = (
                        <div style={{textAlign:"center"}}>
                        <img src={successset} style={{width:"40%"}}/>
                        <div>关注成功</div>
                        <div style={{color:"#FEB607"}}>{this.getSubStr(resp.data)}</div>
                        </div>
                    )
                    this.setState({
                        visible2:true,
                        content:content
                    })
                } else if(resp && resp.code === 205){
                    let content = (
                        <div style={{textAlign:"center"}}>
                            <img src={errSet} style={{width:"40%"}}/>
                            <div>二维码已失效，请联系管理员重新获取二维码</div>
                        </div>
                    )
                    this.setState({
                        visible2:true,
                        content:content
                    })
                    //this.wxReset();
                } else if(resp && resp.code === 400){
                    message.error(resp.message)
                    //this.wxReset();
                }
            }).finally(()=>{
                this.setState({
                    allloading:false
                })
                let query = queryString.parse(this.props.location.search)
                if(query&& query.type){
                    delete query.type;
                    delete query.value;
                    this.props.history.replace("/sub?"+queryString.stringify(query))
                }
                this.getSubList()
            })
        }
    }
    doUnsub=(id)=>{
        let wxToken = this.readToken();
        let token = wxToken.accessToken;
        let openId = wxToken.openid;
        let data = {};
        if(Number.isInteger(id)) {
            data = {
                openid:openId,
                token: token,
                id:id,
            }
            let result = ajax(baseUrl + "/d/public/subscribe", data, "DELETE");
            result.then((resp) => {
                if (resp && resp.code === 400) {
                    message.error(resp.message)
                    this.wxReset();
                } else {
                    message.info("取消订阅成功")
                }
            }).finally(() => {
                this.setState({
                    loading:false,
                    visible:false
                })
                this.getSubList()
            })
        }
    }
    checkToken=(token,openId)=>{
        let url=wx_ser_url+"/token/check?token="+token+"&openid="+openId
        let result = ajax(url);
        result.then((resp) =>{
            if(resp.user&&resp.user.openid) {
                if(resp.user.subscribe!==1){
                    this.doCheckSub()
                }else if (resp.user.subscribe===1){
                    this.doSuccess()
                }
                this.setState({
                    openid:resp.user.openid,
                    sub:resp.user.subscribe,
                    nickname:resp.user.nickname
                })
            }else{
                this.gotoWx()
            }
        }, (error)=> {
            this.gotoWx()
        });
    }
    wxReset=()=>{
        window.localStorage.removeItem("token")
        window.localStorage.removeItem("openid")
        window.localStorage.removeItem("wxToken")
    }
    componentWillMount() {
        // this.setState({
        //     visible2:true,
        //     value:"佳成国际"
        // })
        // return
        //this.wxReset()
        let query = queryString.parse(this.props.location.search)
        let code = query.code;
        this.subInfo = query

        if(this.subInfo){
            this.setState({
                subInfo:this.subInfo
            })
        }
        if(code){
            this.getToken(code);
        }else {
            this.getUserInfo();
        }
    }

    componentDidMount() {

    }

    onLook = () => {
        this.props.history.replace('/companyBindOpt')
    }


    showConfirm =(info) => {
        this.setState({
            value:this.getSubStr(info),
            id:info.id,
        },()=>{
            this.setState({
                visible:true,
            })
        })
    }

    render () {
        const { visible } = this.state;
        return (
            <div className='mobile-upload'>
                <Helmet
                    meta={[
                        {name: "viewport", content: "width=device-width,initial-scale=1.0,user-scalable=no"},
                    ]}
                    title="呜呜网"
                />
                <div className='mobile-upload-header'>
                    <img src={Logo} alt="Logo"/>
                </div>
                <div className='subscribe'>
                    {this.state.sub ===0?
                        <div className='attention'>
                        <div className='attention-bg'>
                        <img src={subCode} alt='subCode'/>
                        </div>
                        <div className='attention-code'>
                        <img src={wx} alt='wx'/>
                        </div>
                        </div>
                        :
                        <Spin spinning={this.state.allloading}>
                            <div className='subscribe-title'>
                                已关注企业
                            </div>
                            {this.state.subList && this.state.subList.length>0?
                                <div className="subscribe-list">
                                    {this.state.subList.map((info,index)=>{
                                        return (
                                            <div className="subscribe-list-item" key={info.id}>
                                                <div className="company-info">
                                                    <img src={EnterPrise} alt="EnterPrise"/>
                                                    <span className="company-info-name">
                                                        {this.getSubStr(info)}
                                                    </span>
                                                </div>
                                                <div className='unBind-opt'>
                                                <span className='unBind-opt-info'>
                                                    <img src={LinkIcon} alt="LinkIcon"/>
                                                    <span onClick={()=>{this.showConfirm(info)}}>
                                                        取消关注
                                                    </span>
                                                </span>

                                                </div>
                                            </div>
                                        )
                                    })}
                                </div>
                                :
                                <div className='company-unbind'>
                                    <div className="company-unbind-bg">
                                        <img src={NoCompany} alt="NoCompany"/>
                                    </div>
                                    <div className="company-unbind-info">
                                        暂无关注企业
                                    </div>
                                    <div className="company-unbind-opt">
                                        <div style={{fontSize:"0.8rem",padding:8,color:"#1592D5",border:"1px solid",width:"fit-content",margin:"auto"}}  onClick={this.onLook}>查看企业关注教程</div>
                                    </div>
                                </div>
                            }
                        </Spin>
                    }
                </div>
                <Modal className={"sub_modal"}
                    visible={visible}
                    onOk={()=>{}}
                    onCancel={()=>{this.setState({visible: false})}}
                    footer={[<Button.Group style={{width:"100%"}} key={"btgroup001"}>
                        <Button type='primary' style={{width:"50%"}} loading={this.state.loading} onClick={()=>{this.setState({loading:true});this.doUnsub(this.state.id)}}>确定</Button>
                        <Button style={{width:"50%"}} onClick={()=>{this.setState({visible: false})}}>取消</Button>
                    </Button.Group>]}
                >
                    <div className='subscribe-info-box'>
                        <div>您确定取消对</div>
                        <div style={{color:"#FEB607"}}>{this.state.value}</div>
                        <div>的关注吗？</div>
                    </div>
                </Modal>
                <Modal className={"sub_modal2"}
                       visible={this.state.visible2}
                       onOk={()=>{}}
                       onCancel={()=>{this.setState({visible2: false})}}
                       footer={[<Button.Group style={{width:"100%",textAlign:"center"}}>
                           <Button style={{width:"60%",borderColor:"#FEB607",color:"#FEB607"}} onClick={()=>{this.setState({visible2: false})}}>知道了</Button>
                       </Button.Group>]}
                >
                    <div className='subscribe-info-box'>
                        {this.state.content}
                    </div>
                </Modal>
            </div>

        );
    }
}
export default SubscribeList